export const HERO_SECTION_COPY = {
  mainHeading: "Recipe Boxes from Gousto: The UK's best food box for choice",
  descriptionParagraph1:
    "Looking for easy, delicious meals to make at home? Gousto's food box delivery service has you covered.",
  descriptionParagraph2:
    "With over 175 tasty recipes to choose from every week, there's something for everyone.",
  ctaButtonText: "Explore this week's menu",
  imageAltText:
    'A range of Gousto recipes from our 10-minute meals, global cuisines and family classics, all packed with fresh ingredients.',
}
